import axios from "../../../apis/Api";
import history, { logout } from "../../../history";
import { GET_1BILL_PAYMENT_REPORT } from "../../../Types";
import { toast } from "react-toastify";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import * as XLSX from "xlsx";
import fileSaver from "file-saver";
import moment from "moment";

export const getOneBillPaymentReport = (postedData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/M2DReports/GetOneBillPaymentReport`, postedData)
    .then(({ data }) => {
      dispatch({
        type: GET_1BILL_PAYMENT_REPORT,
        payload: data.response,
      });
      dispatch(hideLoading());
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = "";
          var errors = error.response.data.errors;
          var keys = Object.keys(errors);
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + " , \n";
          }
          toast.error(errorMessage);
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      } else toast.error("Error while processing the request");
    });
};

export const exportReport = (requestData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/M2DReports/GetOneBillPaymentReport`, requestData)
    .then(({ data }) => {
      const outputFilename = `1Bill_Payment_Report${Date.now()}`;
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";

      const exportToCSV = (csvData, jobNumber, fileName) => {
        const ws = XLSX.utils.json_to_sheet(csvData);
        if (ws) {
          var range = XLSX.utils.decode_range(ws["!ref"]);
          for (var C = range.s.c; C <= range.e.c; ++C) {
            var address = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
            if (!ws[address]) continue;
                  ws[address].v =
                    ws[address].v == "distributor"
                      ? "Distributor"
                      : ws[address].v == "distcenter"
                      ? "Distribution Center"
                      : ws[address].v == "deliverymanTillId"
                      ? "Deliveryman Till ID (Vizlink Till No)"
                      : ws[address].v == "deliverymanName"
                      ? "Deliveryman Name"
                      : ws[address].v == "deliverymanUserName"
                      ? "Deliveryman User Name"
                      : ws[address].v == "shopCode"
                      ? "Shop Code"
                      : ws[address].v == "vizId"
                      ? "Viz ID"
                      : ws[address].v == "shopName"
                      ? "Shop Name"
                      : ws[address].v == "invoiceNumber"
                      ? "Dist. Inv No."
                      : ws[address].v == "invoiceDate"
                      ? "Inv Date (Delivery Date)"
                      : ws[address].v == "invoiceAmount"
                      ? "Inv Amount (edit invoice amount by SK)"
                      : ws[address].v == "originalInvoiceValue"
                      ? "Original Invoice Value"
                      : ws[address].v == "date"
                      ? "Date (Payment Date)"
                      : ws[address].v == "psidDate"
                      ? "PSID Date (on which PSID is generated)"
                      : ws[address].v == "psid"
                      ? "PSID"
                      : ws[address].v == "psidAmount"
                      ? "PSID Amount"
                      : ws[address].v == "bankName"
                      ? "Bank Name"
                      : ws[address].v == "transactionId"
                      ? "Transaction ID"
                      : ws[address].v == "paymentDate"
                      ? "Payment Date (on which payment is done)"
                      : ws[address].v == "paidAmount"
                      ? "Amount Paid"
                      : ws[address].v == "paymentType"
                      ? "Payment Type (1Bill)"
                      : ws[address].v == "paymentStatus"
                      ? "Payment Status (Paid/Unpaid)"
                      : ws[address].v;
        }
      }

        const wb = {
          Sheets: { data: ws },
          SheetNames: [`data`],
        };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const fileData = new Blob([excelBuffer], { type: fileType });
        fileSaver.saveAs(fileData, fileName + fileExtension);
      };

      exportToCSV(data.response?.data, "", outputFilename);
      dispatch(hideLoading());
    })

    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      }
    });
};
